
























import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CFooter",
  components: {}
})
export default class CFooter extends Vue {}
